// Common namespace: small shared UI strings reused across pages.
const common = {
  readMore: 'Read more',
  back: 'Back',
  loading: 'Loading',
  viewProject: 'View project',
  getInTouch: 'Get in touch',
};

export default common;
